<script lang="ts" setup>
    import type { HTMLAttributes } from 'vue';
    import { cn } from '@/lib/utils';
    import { Primitive, type PrimitiveProps } from 'reka-ui';

    const props = withDefaults(
        defineProps<PrimitiveProps & { class?: HTMLAttributes['class'] }>(),
        {
            as: 'a',
        },
    );
</script>

<template>
    <Primitive
        data-slot="breadcrumb-link"
        :as="as"
        :as-child="asChild"
        :class="cn('text-primary hover:text-primary-dark transition-colors', props.class)"
    >
        <slot />
    </Primitive>
</template>
